

















































































/**
 * 홈 - 웹소설 - 상세
 * 메뉴명: 웹소설 상세
 * 메뉴이름: NOVEL_CONTENTS_DETAIL
 */
import { useRouter } from '@u3u/vue-hooks';
import { computed, defineComponent, ref } from '@vue/composition-api';

import { NovelDTO } from '@/apis/repositories/types/novel';
import { fetchNovelDetail } from '@/apis/services/novelService';
import { Breadcrumb, LineBreakElement, WPageWrapper } from '@/components/base';
import BookAuthor from '@/components/views/book/BookAuthor.vue';
import BookCover from '@/components/views/book/BookCover.vue';
import BookInfoSummary from '@/components/views/book/BookInfoSummary.vue';
import BookInfoTitle from '@/components/views/book/BookInfoTitle.vue';
import BookPublishingItem from '@/components/views/book/BookPublishingItem.vue';
import BookStoreTagList from '@/components/views/book/BookStoreTagList.vue';
import { ROUTE_NAMES, SHARE_TYPE } from '@/constants';
import logger from '@/modules/logger';
import { commonCodeStore } from '@/store/commonCode';

export default defineComponent({
  name: 'NovelDetailPage',
  components: {
    Breadcrumb,
    WPageWrapper,
    BookAuthor,
    BookPublishingItem,
    BookStoreTagList,
    BookInfoSummary,
    BookInfoTitle,
    BookCover,
    LineBreakElement,
  },
  setup() {
    const { route, router } = useRouter();
    const novelDetail = ref<NovelDTO | null>(null);

    const novelSeq = computed(() => {
      return Number(route.value.params.id);
    });

    // const ageRatingText = computed(() => (!novelDetail.value ? '' : AGE_LIMIT_OPTION[novelDetail.value.ageLimit]));
    const ageRatingText = computed(
      () => commonCodeStore.listItem('AgeLimitType', !novelDetail.value ? '' : novelDetail.value.ageLimit)?.text,
    );

    const novelCategoryTyep = computed(() => {
      //todo:@dwkim - 로맨스 판타지가 서버에서 로판으로 넘어온다.. 서버 수정 가능하면 바로 text 리턴
      const category = commonCodeStore.listItem(
        'NovelCategoryType',
        !novelDetail.value ? '' : novelDetail.value?.category,
      );

      return category.code === 'ROMANCE_FANTASY' ? '로맨스판타지' : category.text;
    });

    const getNovelDetail = async () => {
      try {
        const response = await fetchNovelDetail(novelSeq.value);
        if (!response) {
          router.replace({ name: ROUTE_NAMES.NOT_FOUND });
        } else {
          novelDetail.value = response;
        }
      } catch (error) {
        logger.log('alpha', '웹소설 상세 요청 실패.', error);
        router.replace({ name: ROUTE_NAMES.NOT_FOUND });
      }
    };

    const fetchData = () => {
      return getNovelDetail();
    };

    return {
      novelDetail,
      ageRatingText,
      fetchData,
      SHARE_TYPE,
      novelCategoryTyep,
    };
  },
});
